const { gql } = require('@apollo/client')

const createFileType = gql(`
  mutation createFileType($project: String, $input: FileTypeInput!){
    createFileType(
      input : $input
      project : $project
      # module : $module
    ){
      id
      name
      isEnabled
      extension
      key
    }
  }  
`)

export default createFileType
